type HowlCallback = (...args: unknown[]) => void

export class Howl {
  constructor(_opts?: unknown) {}

  play() {
    return 0
  }

  pause() {}

  stop() {}

  unload() {}

  seek(_pos?: number) {
    return 0
  }

  volume(_vol?: number) {
    return 1
  }

  duration() {
    return 0
  }

  playing() {
    return false
  }

  on(_event: string, _fn: HowlCallback) {
    return this
  }

  once(_event: string, _fn: HowlCallback) {
    return this
  }

  off(_event?: string, _fn?: HowlCallback) {
    return this
  }
}

export const Howler = {
  autoUnlock: true,
  html5PoolSize: 10,
  volume(_vol?: number) {
    return 1
  },
  mute(_muted?: boolean) {},
}
